import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import SEO from '../../../components/SEO';
import Layout from '../../../layouts/index';
import HtmlParser from 'html-react-parser';
import JoinHappyCustomers from '../../../components/JoinHappyCustomers';
import { DemoFormLong } from '../../../components/DemoFormLong.jsx';
import { DemoFormShortPDFNoBackground } from '../../../components/DemoFormShortPDFNoBackground.jsx';

const KeysMaintainingScaleMassiveGrowth = (props) => {
    const json = props.data.allTestimonialsJson.edges;

    function shuffle(array) {
        array.sort(() => Math.random() - 0.5);
    }

    shuffle(json);
    const location = props.location;


    return (
        <Layout bodyClass="building-blocks-pay-equity" ontouchstart>
            <SEO title="Infographic: 4 Building Block of Pay Equity | ChartHop" />
            <Helmet>
                <meta
                    name="description"
                    content="A data-based approach to compensation and pay equity will allow you to mitigate any bias already in your payroll and create a total rewards strategy that is both fair and competitive. Download this infographic to see how to get it done in 4 steps."
                />
                <meta property="og:url" content={`https://www.charthop.com${location.pathname}`} />
                <meta property="og:title" content="Infographic: 4 Building Block of Pay Equity | ChartHop" />
                <meta property="og:description" content="A data-based approach to compensation and pay equity will allow you to mitigate any bias already in your payroll and create a total rewards strategy that is both fair and competitive. Download this infographic to see how to get it done in 4 steps." />
                <meta property="og:image" content={`https://www.charthop.com/resources/guides-ebooks/4-building-blocks/CH_4-building-blocks-meta-image-landingpage_V1.png`} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:site_name" content="ChartHop" />
                {/* Twitter Card tags */}
                <meta name="twitter:title" content="Infographic: 4 Building Block of Pay Equity | ChartHop" />
                <meta name="twitter:description" content="A data-based approach to compensation and pay equity will allow you to mitigate any bias already in your payroll and create a total rewards strategy that is both fair and competitive. Download this infographic to see how to get it done in 4 steps." />
                <meta name="twitter:image" content={`https://www.charthop.com/resources/guides-ebooks/4-building-blocks/CH_4-building-blocks-meta-image-landingpage_V1.png`} />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@charthop" />
                <meta name="twitter:creator" content="@charthop" />

            </Helmet>

            {/* HEADER h4*/}
            <section className="hero-dei-reporting">
                <div className="row bottom-formPDF sectionSpacing contentBlock section-big">
                    <div className="headerContent col-md-6 col-sm-12 text-left padding-left-headerContent">
                        <img 
                            src="/resources/guides-ebooks/4-building-blocks/CH_4-building-blocks-title_V1.svg" 
                            alt="4 building blocks of pay equity"
                        />
                    </div>
                </div>
                <div className="top-formPDF sectionSpacing contentBlock justify-content-md-start justify-content-center section-big">
                    <a href="/resources/guides-ebooks/4-building-blocks/4 Building Blocks of Pay Equity Infographic.pdf" className="download-orange" target="_blank">DOWNLOAD</a>
                    {/*<DemoFormShortPDFNoBackground pdfUrl={'/resources/guides-ebooks/people-pioneer/Charthop_People-Pioneers-Winners-Magazine_PDF.pdf'} source={"resources-People-Pioneers-2022-Winners-2022-PDF-contentdownload-header"} />*/}
                </div>
            </section>

           <section className="sectionSpacing flex-centeredColumn dei-section">
                <div className="contentBlock">
                    <h2 className="text-center mt-0  sectionSpacing-Margin planForwardTitle"> 
                        A data-based approach to compensation and pay equity will allow you to mitigate any bias already in your payroll and create a total rewards strategy that is both fair and competitive.
                        <br /><br />
                        Easier said than done, right?
                    </h2>
                    <div className="flex-centeredColumn contentBlock">
                        <p className="text-center my-2 planForwardSubTitle">
                            <a href="/resources/guides-ebooks/4-building-blocks/4 Building Blocks of Pay Equity Infographic.pdf" className="download-blue" target="_blank">
                                → Download
                            </a> this infographic to see how HR leaders across industries get it done.
                        </p>
                    </div>
                </div>
            </section>

            {/* TRUSTED */}
            <section className="customer testimonial-container pt-8 pb-5 backgroundGradientContainer">
                <JoinHappyCustomers title={HtmlParser('Trusted <span class="blue-text">by</span>')}></JoinHappyCustomers>
            </section>
  
            {/* LONG FORM */}
            <section name="request-demo " id="request-demo" className="request-demo request-demo-white pt-3 pb-4 pt-md-8 pb-md-8">
                <DemoFormLong source={"resources-CFO-headcount-planning-2022-demo-bottom"} headertext={HtmlParser('<div class="contactTestimonial pr-md-1"><p class=" mb-3 contact-testimonial">"I value ChartHop so much as a People leader. The system is comprehensive, the UI is intuitive and the workflow is clean and logical. Unlike many other HR systems, there is no selling required to yield internal adoption. Once my business owners were provided access and given a tour of the dashboards we built for them, they were hooked."</p><div class="authorTag"><img src="/customers/even/kyle-roberts_even-th.jpg" class="testimonialAuthor" alt="Weifang Zhu" /><div><p class="contactAuthor"><strong>Kyle Roberts</strong> <br>Chief People Officer, Even Financial</p></div></div>')}/>
            </section>

        </Layout>
    );
};


export default KeysMaintainingScaleMassiveGrowth;

export const query = graphql`
  query {
    allTestimonialsJson {
      edges {
        node {
          id
          name
          title
          quote
          image
        }
      }
    }
  }
`;